module.exports = __webpack_public_path__ + "static/img/ftshopping-bag.39425db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ftshopping-bag.png
// module id = d4El
// module chunks = 0